import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { LoanappService } from './../../services/loanapp.service';

declare var $: any;

@Component({
  selector: 'app-approvedloanreport',
  templateUrl: './approvedloanreport.component.html',
  styleUrls: ['./approvedloanreport.component.css'],
})
export class ApprovedloanreportComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  toDate: any;
  fromDate: any;

  constructor(
    private lservice: LoanappService,
    private router: Router,
    private auth: AuthService
  ) {}

  ngOnInit() {
    // this.ngxLoader.start();
    let obj = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      type: 'by-date',
    };
    this.lservice.getApprovedLoanReport(obj).subscribe((data) => {
      this.dataRec = true;
      if (data['success']) {
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        for (let i = 0; i < this.dataToShow.length; i++) {
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
      }
    });
  }
  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  onSearchChange(val){}
  onChangeWname(val){}
  onChangeStatus(val){}
  downloadCSV(){}
  downloadPDF(){}
  print(){}

}
